<template>
  <div class="starter-page" @dblclick="handleDblClick">
    <div
      class="navbar-dark project-header px-4 py-2 d-flex justify-content-between"
    >
      <div class="gantt-title-wrapper">
        <span
          v-if="query && Object.keys(query).length == 0 && false"
          class="align-middle ticket-title__client-name pl-0 project-home"
          >{{ demoText }} Projects</span
        >

        <!-- <a v-if="query && Object.keys(query).length > 0" @click="_onResetSearchClicked">
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a> -->
        <span
          v-if="query && Object.keys(query).length > 0 && searchResults"
          class="align-middle ticket-title__client-name pl-0 project-home"
        >
          {{ searchResults && searchResults.data.length }}
          <span>
            {{ searchResults.data.length > 1 ? "Projects" : "Project" }} </span
          >found {{ q ? ". For " + q : "" }}</span
        >

        <!-- <button class="btn btn-primary align-middle ticket-title__client-name pl-3"> <i class="fa fa-plus"></i> {{demoText}} Add new Projects</button> -->
        <!-- <base-button
          v-if="profile && profile.role && profile.role.name == 'guest'"
          size="sm"
          class="borderRadius-25 m-1 ml-3"
          type="success"
          @click="$emit('loginClicked')"
        >Sign in</base-button> -->
      </div>
      <div class="d-flex align-items-center" v-if="false">
        <button
          class="btn btn-sm text-white bg-info my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
          v-if="profile && profile.role && profile.role.name != 'guest'"
          @click="$router.push({ name: 'timesheet.home' })"
        >
          My Timesheet
        </button>
      </div>
    </div>
    <Gantt
      v-if="
        query &&
        (Object.keys(query).length == 0 ||
          Object.keys(query).some((q) => q == 'redirect' || q == 'login')) &&
        projects &&
        profile
      "
      :tasks="projects"
      :currency="profile.currency"
      :enableResize="false"
      :ganttView="profile.ganttViewMode"
      :ganttDay="profile.ganttDayMode"
      :ganttComment="ganttCommentMode"
      :ganttZoom="profile.ganttZoomMode"
      :showBilling="profile.showFinance == '1'"
      color-class
      @dblClickEmptyArea="handleTaskDblClick"
      @task-link-clicked="handleProjectLinkClick"
      @task-dbl-click="handleTaskDblClick"
      @task-dragged="handleTaskDragged"
      @assigned-by-user-clicked="handleAssignedByUserClicked"
      @assigned-to-user-clicked="handleAssignedToUserClicked"
    />

    <Gantt
      v-if="
        query &&
        Object.keys(query).length > 0 &&
        !Object.keys(query).some((q) => q == 'redirect' || q == 'login') &&
        searchResults &&
        profile
      "
      :tasks="searchResults"
      :currency="profile.currency"
      :ganttView="profile.ganttViewMode"
      :ganttDay="profile.ganttDayMode"
      :ganttComment="ganttCommentMode"
      :ganttZoom="profile.ganttZoomMode"
      :enableResize="false"
      :showBilling="profile.showFinance == '1'"
      color-class
      @dblClickEmptyArea="handleTaskDblClick"
      @task-link-clicked="handleProjectLinkClick"
      @task-dbl-click="handleTaskDblClick"
      @task-dragged="handleTaskDragged"
      @assigned-by-user-clicked="handleAssignedByUserClicked"
      @assigned-to-user-clicked="handleAssignedToUserClicked"
    />

    <!-- <div class="project__details d-flex justify-content-center align-items-center" style="height:61px" v-if="projects">
     <base-button
     outline
                      type="success"
                      class="btn btn-sm success-btn"
                      @click="$refs.myBottomSheet.open();"
                      >Archived Projects</base-button
                    >
    </div>

    <vue-bottom-sheet ref="myBottomSheet">
      <archived 
      :tasks="archievedProjects"
      @taskClick="_onArchivedTaskClick"
      :max-width="'80%'"/>
    </vue-bottom-sheet> -->
  </div>
</template>
<script>
import moment from "moment";
import Gantt from "@/app/components/Gantt.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import Archived from "../components/Archived.vue";
export default {
  name: "ProjectHome",
  props: ["projectCreateFlag"],
  components: {
    Gantt,
    Archived,
  },
  data() {
    return {
      sideBarShow: true,
      q: null,
      searchResults: null,
      query: null,
    };
  },
  computed: {
    ...mapState("project", ["projects", "archievedProjects"]),
    ...mapState(["ganttRender"]),
    ...mapState("user", ["profile"]),
    searchMode() {
      return (
        (this.query && Object.keys(this.$route.query).length > 0) ||
        (this.query &&
          Object.keys(this.$route.query).length > 0 &&
          (this.query.archiveProjectTitle ||
            this.query.activeProjectTitle ||
            this.query.searchTaskTitle ||
            this.query.searchTaskText))
      );
    },
    demoText() {
      return this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
        ? "Demo"
        : "";
    },

    ganttCommentMode() {
      return this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
        ? "task-title"
        : this.profile.ganttCommentMode || "task-title";
    },
  },
  watch: {
    async projectCreateFlag(val) {
      await this.refreshRecords();
    },
    async $route(to, from) {
      this.query = this.$route.query;
      this.refreshRecords();
    },
  },
  mounted() {
    this.$nextTick(async () => {
      this.query = this.$route.query;
      this.refreshRecords();
    });
  },

  methods: {
    ...mapActions("project", [
      "fetchAllProjects",
      "updateProjectStatus",
      "fetchArchievedProjects",
    ]),
    ...mapActions("project", ["searchProject"]),
    ...mapMutations(["setGanttRender"]),
    ...mapMutations(["setLoading"]),

    async refreshRecords() {
      console.log("query nnnnnnnn ", this.query.q);
      this.setLoading(true);
      if (this.searchMode) {
        let result = await this.searchProject({ ...this.query });
        this.searchResults = result;
      } else {
        try {
          await this.fetchAllProjects();
          this.setGanttRender();
          this.setLoading(false);
        } catch (err) {
          this.setLoading(false);
        }
      }

      // await this.fetchArchievedProjects({ query: this.q });
    },

    _onResetSearchClicked() {
      this.setLoading(true);
      this.$router.replace({ query: null }).catch(() => {});
    },

    _onArchivedTaskClick(task) {
      //this.handleTaskDblClick(task.id, null, task)
      this.$emit("taskDblClick", task.id, null, task);
      this.$refs.myBottomSheet.close();
    },

    handleDblClick() {
      this.setLoading(true);
      setTimeout(() => {
        console.log("c", this.sideBarShow);
        if (this.sideBarShow) {
          this.$emit("dblClick");
        }
        this.sideBarShow = true;
        this.setLoading(false);
      }, 2000);
    },

    handleProjectLinkClick(id, task) {
      // this.$snack.danger({text: 'hello', button: "OK", action: ()=> {
      //   this.$snack.close()
      // }})
      // return false
      console.log("b", id);

      if (id) {
        this.sideBarShow = false;
        if (id == "assigned-tasks" || id == "assigned-by") {
          this.$snack.success("Can not edit view only project");
        } else {
          let name = null;
          if (Object.keys(this.$route.query).length == 0) {
            name = this.projects.data.filter((r) => r.id == id)[0].name;
          } else {
            name = this.searchResults.data.filter((r) => r.id == id)[0].name;
          }

          if (name) {
            name = name.toLowerCase();
            if (name == "can you fix me") {
              this.$snack.success("Can not edit view only project");
            } else {
              this.$emit("taskDblClick", id, event, task);
            }
          }
        }
      } else {
        this.sideBarShow = true;
      }
    },
    handleAssignedToUserClicked(id, userId) {
      //alert(userId+' '+id)
    },
    handleAssignedByUserClicked(id, userId, task) {
      //alert(userId+' '+id)
      if (task.permission && task.permission.edit == 1) {
        this.$emit("assignedByUserClicked", id, userId);
      } else {
        this.$snack.success("You can not edit this project.");
      }
    },
    handleTaskDblClick(id, event, task) {
      if (id) {
        console.log(id, "sagard");
        let name = "";
        if (Object.keys(this.$route.query).length == 0) {
          name = this.projects.data.filter((r) => r.id == id)[0].name;
        } else {
          name = this.searchResults.data.filter((r) => r.id == id)[0].name;
        }

        this.$router.replace({
          name: "tasks.home",
          params: { id: id, name: name },
        });
      }
    },
    async handleTaskDragged(id, e) {
      console.log("Project Dragged", e);
      //return false
      let body = {};
      console.log(e, "Project dragged");
      body.start_date = moment(e.start_date).format("YYYY-MM-DD 00:00:00");
      body.end_date = body.deadline = moment(e.end_date)
        .add(-1, "days")
        .format("YYYY-MM-DD 23:59:59");

      //console.log("Project Dragged body", body)
      body.id = e.id;
      this.setLoading(true);
      try {
        await this.updateProjectStatus(body).then((res) => {
          if (res.data.error) {
            this.$snack.danger(res.data.message);
          } else {
            this.$snack.success("Project Deadline Updated Successfully");
          }
        });
        // if(res.error){
        // this.$snack.error(res.message);
        // }else{
        //   this.$snack.success("Project Deadline Updated Successfully");
        // }
        this.setLoading(false);
        await this.refreshRecords();
        //this.setGanttRender();
      } catch (e) {
        console.log(e, "eeeee");
        this.$snack.danger("Could not update due to server error");
        this.setLoading(false);
        this.refreshRecords();
      }
    },

    onEmptyAreaDblClicked() {
      //alert("a")
      this.$emit("taskDblClick");
    },
  },
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 80px);
}

.gantt-title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
/* .gantt-title-wrapper a {
  padding-right: 3px;
} */
.project-header {
  display: flex;
  flex-direction: row;
  padding: 10px;
}
@media only screen and (max-width: 992px) {
  .gantt-title-wrapper .project-home {
    padding-left: 20px !important;
  }
}
</style>
